// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';
import { Typography } from '@kintent/glide';

import * as Styles from './Documents.styles';
import DocumentList from './components/document-list/DocumentList';
import { MediaQueriesProvider } from '../../../components/MediaQueriesProvider';

// Constants
const DOCUMENT_COPY = 'Documents';

function Documents() {
  return (
    <MediaQueriesProvider>
      <Styles.MainGrid>
        <Styles.DocumentListContainer>
          <Typography
            as="h1"
            level="1"
          >
            {DOCUMENT_COPY}
          </Typography>
          <DocumentList />
        </Styles.DocumentListContainer>
      </Styles.MainGrid>
    </MediaQueriesProvider>
  );
}

export default Documents;
